(function () {
  window.ModifyHelpers = {
    /**
     * Calculate next delivery date
     */
    nextDeliveryDate: function () {
      var today = new Date(),
        friday = new Date();

      var day = today.getDay();
      if (day === 0) {
        day = 7;
      }
      var diff = day - 5;
      friday.setDate(today.getDate() - diff);
      friday.setDate(friday.getDate() + 7);

      var d = new Date();
      var wDay = d.getDay();
      if (wDay === 0) {
        d.setDate(d.getDate() + 5);
      } else {
        d.setDate(d.getDate() + (12 - wDay));
      }

      var yy = d.getFullYear(),
        mm = d.getMonth() + 1,
        dd = d.getDate();

      if (mm < 10) {
        mm = '0' + mm;
      }

      if (dd < 10) {
        dd = '0' + dd;
      }

      return yy + '-' + mm + '-' + dd;
    },
    /**
     * Calculate next delivery date including time shift for 12 hours
     */
    calculateDeliveryDateFromNow: function () {
      var currentDate = new Date();

      //Adjust date is it is Friday and it is holiday
      function adjustDate(date) {
        var newDate = date;
        var _month = new Date(newDate).getMonth() + 1;
        var _date = new Date(newDate).getDate();
        var _day = new Date(scheduledAtDate).getDay();
        var formattedDate = _month + '-' + _date;
        var holidayDates = ['12-25', '1-1'];

        if (_day === 5 && holidayDates.includes(formattedDate)) {
          newDate.setDate(newDate.getDate() - 1);
        }
        return newDate;
      }

      var $this = this;
      //To adjust delivery date on some days forward
      function applyAdjustDate(date) {
        var newDate = date;
        var adjustmentValue = parseInt(
          $this.diet_type === 'Low-FODMAP Plan' ? window.theme.dateAdjustment : window.theme.dateAdjustmentMediterranean
        );

        if (adjustmentValue) {
          newDate.setDate(newDate.getDate() + adjustmentValue);
        }

        return newDate;
      }

      //Adjust user local time to UTC-4 time zone
      var hoursOffset = currentDate.getTimezoneOffset() / 60 - 5;
      currentDate.setHours(currentDate.getHours() + hoursOffset);
      var scheduledAtDate = currentDate;
      var getHours = currentDate.getHours();
      var getWeekDay = scheduledAtDate.getDay();
      var cutOffDeliveryHour = 11;
      //If it is Monday from 0AM till 5AM, then delivery will be this week Friday
      if (getHours >= 0 && getHours < cutOffDeliveryHour && getWeekDay === 1) {
        scheduledAtDate.setDate(scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + 4);
      } else {
        scheduledAtDate.setDate(scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + 11);
      }

      scheduledAtDate = adjustDate(scheduledAtDate);
      scheduledAtDate = applyAdjustDate(scheduledAtDate);

      var year = new Date(scheduledAtDate).getFullYear();
      var month = new Date(scheduledAtDate).getMonth() + 1;
      var date = new Date(scheduledAtDate).getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (date < 10) {
        date = '0' + date;
      }

      return year + '-' + month + '-' + date;
    },
    /**
     * Sort existent items in cart
     */
    prepareSort: function (cart) {
      var toAdd = {
          meal_plan: [],
          dietitian: [],
          addit_m1: {
            b: [],
            l: [],
            d: [],
          },
          addit_m2: {
            b: [],
            l: [],
            d: [],
          },
        },
        items = cart.items;

      this.attrs = {};

      if (items.length > 0) {
        for (var i in items) {
          var item = items[i],
            cartItem = {
              id: item.variant_id,
              qty: item.quantity,
              properties: item.properties,
            };

          if (item.product_type === 'Low-FODMAP Plan' || item.product_type === 'Mediterranean Plan') {
            toAdd.meal_plan.push(cartItem);
          } else if (item.product_type === 'Dietitian') {
            toAdd.dietitian.push(cartItem);
            this.attrs['healthieScheduler'] = 'No';
          } else {
            if (item.properties && item.properties['meal_plan'] === 'm1') {
              if (item.product_type === 'Breakfast') {
                toAdd.addit_m1.b.push(cartItem);
              } else if (item.product_type === 'Entrée') {
                toAdd.addit_m1.l.push(cartItem);
              } else {
                toAdd.addit_m1.d.push(cartItem);
              }
            } else {
              if (item.product_type === 'Breakfast') {
                toAdd.addit_m2.b.push(cartItem);
              } else if (item.product_type === 'Entrée') {
                toAdd.addit_m2.l.push(cartItem);
              } else {
                toAdd.addit_m2.d.push(cartItem);
              }
            }
          }
        }
      }

      return toAdd;
    },
    /**
     * Sort line items, update cart and submit to checkout
     */
    sortCartAndSubmit: function (toAdd, attrs) {
      var data = [],
        types = ['b', 'l', 'd'];

      for (var i in toAdd.meal_plan) {
        data.push(toAdd.meal_plan[i]);
      }
      for (var j in toAdd.dietitian) {
        data.push(toAdd.dietitian[j]);
      }

      for (var k in types) {
        var typeK = types[k];

        for (var _k in toAdd.addit_m1[typeK]) {
          data.push(toAdd.addit_m1[typeK][_k]);
        }
      }

      for (var l in types) {
        var typeL = types[l];

        for (var _l in toAdd.addit_m2[typeL]) {
          data.push(toAdd.addit_m2[typeL][_l]);
        }
      }

      data.reverse();
      CartUtil.data = data;
      CartUtil.total = data.length;
      CartUtil.ini = 0;

      CartUtil.updateAttrs(attrs, function () {
        CartUtil.recursive();
      });
    },
    replaceReservedCharacters: function (str) {
      //Double encoded + symbol, to compensate the Shopify proxy fix
      return str.replace(/\+/g, '%2B');
    },
    launchVideo: function () {
      var videoWrap = document.getElementById('hero-video-wrap'),
        windowWidth = window.innerWidth;

      if (!videoWrap || windowWidth < 768) return false;

      var videoNode = document.getElementById('hero-video-tag');
      var isPlaying =
        videoNode.currentTime > 0 && !videoNode.paused && !videoNode.ended && videoNode.readyState > videoNode.HAVE_CURRENT_DATA;
      videoNode.setAttribute('autoplay', '');
      videoNode.load();
      if (!isPlaying) {
        var playPromise = videoNode.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              //This is intentional
            })
            .catch((err) => {
              ModifyHealth.Sentry.captureException(err);
            });
        }
      }
    },
    init: function () {
      var $this = this;
      window.onload = function () {
        $this.launchVideo();
      };
    },
  };
  window.ModifyHelpers.init();
})();
